"use client";
import AnimatedOwl from "./_components/AnimatedOwl";
import LeftComponent from "./_components/LeftComponent";
import ProfileSelection from "./_components/ProfileSelection";
import Footer from "./_components/Footer";

const SketchieOwlApp = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-300 via-pink-200 to-yellow-200 overflow-hidden relative">
      <div className="container mx-auto px-4 py-8 relative z-10">
        {/* Header Section */}
        {/* Animated Owl */}
        <AnimatedOwl />

        {/* Main Content Area */}
        <div className="grid md:grid-cols-2 gap-8 items-center">
          {/* Left Side - Illustration */}
          <LeftComponent />

          {/* Right Side - Profile Selection */}
          <div className="space-y-8">
            <ProfileSelection />
            {/* Activity Icons */}
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SketchieOwlApp;
